module.exports = __webpack_public_path__ + "img/1 (5).b39296d5.jpg";